var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question-container"},[_c('h1',{staticClass:"type-question",domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }